import 'debug';
import { m as _toConsumableArray, _ as _asyncToGenerator, h as _regeneratorRuntime } from './index2.js';
import 'deepmerge';
import 'axios';
import 'vue';
import DynamicPageInPage from './DynamicPageInPage.js';

var DynamicPage = DynamicPageInPage.extend({
  name: 'DynamicPage',
  computed: {
    dynamicPage: function dynamicPage() {
      switch (this.pageData.Class) {
        case 'XpSplashScreen':
          return 'XpSplashScreenPage';

        case 'XpSelectLanguage':
          return 'XpSelectLanguagePage';

        case 'XpHome':
          return 'XpHomePage';

        case 'XpMenu':
          return 'XpMenuPage';

        case 'XpMap':
          return 'XpMapPage';

        case 'XpMultipleChoice':
          return 'XpMultipleChoicePage';

        case 'XpNfc':
          return 'XpNfcPage';

        case 'XpNumericInput':
          return 'XpNumericInputPage';

        case 'XpError':
          return 'XpErrorPage';

        default:
          return 'XpPage';
      }
    }
  },
  mounted: function mounted() {
    if (this.pageData.Class === 'XpSplashScreen') {
      this.$xp.navigation.hideNav();
      this.$xp.navigation.preventAutoHide();
    } else if (this.pageData.isAutoHideNavAllowed || this.pageData.IsFullScreen) {
      this.$xp.navigation.allowAutoHide();
      this.$xp.navigation.showNav(true);
    } else {
      this.$xp.navigation.preventAutoHide();
      this.$xp.navigation.showNav();
    }
  },
  methods: {
    getPageClasses: function getPageClasses() {
      return {
        'o-page': true,
        'is-padded-for-nav': !this.pageData.isNavOverlapping,
        'is-full-screen': this.$xp.navigation.isFullScreen
      };
    },
    renderAudioPlayer: function renderAudioPlayer(h) {
      // <audio-player
      //   v-eva-media **ONLY IF $xp.evaInstalled
      //   v-if="$xp.navigation.isAudioSynced"
      //   :source="$xp.settings.baseUrl + 'xpedeo/' + pageData.Audio.Url"
      //   :binaryId="pageData.Audio.BinaryID"
      //   :pageId="pageData.ID"
      //   :audioSync="pageData.AudioSync"
      //   :autoPlay="$xp.settings.mergedSettings.navigation.autoPlayPageAudio"
      //   :lipSyncUrl="(pageData.Class === 'XpVideoSync') ? pageData.lipSyncUrl : null"></audio-player>
      return this.$xp.navigation.isAudioSynced ? h('audio-player', {
        props: {
          source: this.$xp.settings.baseUrl + 'xpedeo/' + this.pageData.Audio.Url,
          binaryId: this.pageData.Audio.BinaryID,
          pageId: this.pageData.ID,
          audioSync: this.pageData.AudioSync,
          autoPlay: this.$xp.settings.mergedSettings.navigation.autoPlayPageAudio,
          lipSyncUrl: this.pageData.Class === 'XpVideoSync' ? this.pageData.lipSyncUrl : null
        },
        directives: this.$xp.evaInstalled ? [{
          name: 'eva-media'
        }] : []
      }) : null;
    }
  },
  watch: {
    '$xp.navigation.activeTabId': {
      handler: function () {
        var _handler = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(newVal, oldVal) {
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  if (newVal && newVal !== oldVal && // avoid uneeded router replaces
                  this.pageData.Class !== 'XpHome' && // do not replace route on Home pages, the home page loads the content
                  newVal !== parseInt(this.$route.params.id) // avoid triggering duplicate routes (happens on the first load of this page)
                  ) {
                      this.$router.replace("/page/".concat(newVal));
                    }

                case 1:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, this);
        }));

        function handler(_x, _x2) {
          return _handler.apply(this, arguments);
        }

        return handler;
      }()
    }
  },
  render: function render(h) {
    return this.pageData.ID ? h(this.dynamicPage, {
      props: {
        localPageData: this.pageData
      },
      class: this.getPageClasses(),
      key: this.pageData.ID
    }, [].concat(_toConsumableArray(this.renderSections(h)), [this.renderAudioPlayer(h)], _toConsumableArray(this.renderEntryNav(h)))) : null;
  }
});

export default DynamicPage;
